// Playlists
export const PLAYLIST_INDEX_REQUEST: string = "Vendor/Playlists/INDEX_REQUEST";
export const PLAYLIST_INDEX_SUCCESS: string = "Vendor/Playlists/INDEX_SUCCESS";
export const PLAYLIST_INDEX_FAILURE: string = "Vendor/Playlists/INDEX_FAILURE";

export const PLAYLIST_SHOW_REQUEST: string = "Vendor/Playlists/SHOW_REQUEST";
export const PLAYLIST_SHOW_SUCCESS: string = "Vendor/Playlists/SHOW_SUCCESS";
export const PLAYLIST_SHOW_FAILURE: string = "Vendor/Playlists/SHOW_FAILURE";

export const PLAYLIST_SET_FILTERS: string = "Vendor/Playlists/SET_FILTERS";

// Vendor tracks
export const TRACK_INDEX_REQUEST: string = "Vendor/Tracks/INDEX_REQUEST";
export const TRACK_INDEX_SUCCESS: string = "Vendor/Tracks/INDEX_SUCCESS";
export const TRACK_INDEX_FAILURE: string = "Vendor/Tracks/INDEX_FAILURE";
